<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'SupportCategoryCenter',
            to: {
              name: 'SupportCategoryCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'SupportCategoryCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增項目</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增項目 -->
    <SupportCategoryCreateEdit></SupportCategoryCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportCategoryCreateEdit from '@/views/G-2__SupportCategory/c/SupportCategoryCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    SupportCategoryCreateEdit,
  },
  computed: {
    ...mapState('supportcategory', ['supportcategory']),
  },
  created() {
    this.setSupportCategory({});
  },
  methods: {
    ...mapActions('supportcategory', ['setSupportCategory', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'SupportCategoryCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.supportcategory.title) {
          this.errors.push('標題 required.');
        } else if (!this.supportcategory.bu_id) {
          this.errors.push('BU required.');
        } else if (!this.supportcategory.type) {
          this.errors.push('類型 required.');
        } /* else if (!this.supportcategory.slug) {
          this.errors.push('Slug required.');
        } */
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.supportcategory).then(() => {
          this.$router.push({ name: 'SupportCategoryCenter' });
        });
      }
    },
  },
};
</script>
<style></style>
